export const text = {
  quickLinks: "Quick Links",
  others: "Others",
  contactUs :"Feel free to get in touch with us !",
};
